import React from 'react';
export function SiteFooter() {
  return <footer className="border-t border-ink/10 px-6 py-8 md:px-10" data-id="element-54" data-mp="348oflv2iyool">
      <p className="font-sans text-[9px] font-medium uppercase tracking-[0.3em] text-ink/60" data-id="element-55" data-mp="1t5udefhsbpqc">
        Twenty Mile House · 138 Old Cromberg Road, Graeagle, CA 96103
      </p>
    </footer>;
}